module.exports = __webpack_public_path__ + "img/res009.8a5c7c97.png";